import DOMPurify from "dompurify";

const isEmptyParagraph = (paragraph: HTMLParagraphElement) => {
  const text = (paragraph.textContent ?? "").replace(/\u00A0/g, "").trim();
  if (text.length > 0) return false;

  // Treat paragraphs that only contain <br> (or whitespace) as empty.
  return Array.from(paragraph.childNodes).every((node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      return (node.textContent ?? "").trim() === "";
    }
    if (node.nodeType === Node.ELEMENT_NODE) {
      return (node as Element).tagName === "BR";
    }
    return true;
  });
};

export const normalizeRichTextHtml = (html: string): string => {
  if (!html?.trim()) return "";

  const sanitized = DOMPurify.sanitize(html);
  if (typeof window === "undefined" || typeof DOMParser === "undefined") {
    return sanitized;
  }

  const doc = new DOMParser().parseFromString(sanitized, "text/html");
  doc.body.querySelectorAll("p").forEach((paragraph) => {
    if (isEmptyParagraph(paragraph)) {
      paragraph.remove();
    }
  });

  // DOMPurify strips `target`; open links in a new tab so they don't
  // navigate away from the embedded widget.
  doc.body.querySelectorAll("a[href]").forEach((link) => {
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");
  });

  return doc.body.innerHTML.trim();
};

